var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTileIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#D7DDDD;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:square;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.01,
    y: 19.12,
    className: "st1",
    width: 27.96,
    height: 27.96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.45,39.31l-4.18,2.2l1.18-6.88l-5-4.87l6.91-1l3.09-6.26l3.09,6.26l6.91,1l-3,2.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.45,42h-9 M102.45,37h-9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 16,
    cy: 18.16,
    r: 0.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 16,
    y1: 18.7,
    x2: 16,
    y2: 20.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.97,15.21h8.06c0.3,0,0.54,0.24,0.54,0.54v6.45c0,0.3-0.24,0.54-0.54,0.54h-8.06 c-0.3,0-0.54-0.24-0.54-0.54v-6.45C11.43,15.45,11.67,15.21,11.97,15.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.04,13.32c0-1.63,1.32-2.96,2.96-2.96s2.96,1.32,2.96,2.96v1.88h-5.91V13.32z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon01);
export default __webpack_public_path__ + "static/media/feature-tile-icon-01.bbb602aa59c42294e74d2e55bbab5415.svg";
export { ForwardRef as ReactComponent };